export default {
  /** Media query for phone layout breakpoint */
  phone: "(max-width: 600px)",

  /** Media query for tablet layout breakpoint */
  tablet: "(max-width: 840px), (max-height: 600px)",
};
